import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

export const container: CSSProperties = {
  paddingBottom: 10,
};

export const intro: CSSProperties = {
  color: greys.slate,
  fontSize: 14,
  lineHeight: 1.5,
};

export const addSlack: CSSProperties = {
  paddingTop: 10,
};

export const slackAccounts: CSSProperties = {
  width: "100%",
  marginTop: spacing.std,
  flexGrow: 1,
};

export const tabs: CSSProperties = {
  border: `1px solid ${greys.borderGrey}`,
};

export const tabLabel: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const needsUpdate: CSSProperties = {
  marginRight: 5,
};

export const tabContent: CSSProperties = {
  border: `1px solid ${greys.borderGrey}`,
  borderTop: "none",
  padding: spacing.lg,
  marginBottom: spacing.sm,
};
